import React from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";

// Fires once when the getting-started checklist hits 5/5 (kind
// "checklist_complete" on the celebration queue, acked on display). Kept
// deliberately gentle: no confetti, no motion — reduced-motion safe by
// construction, matching the welcome that opens the arc.
const CIRCUIT = [
  "Profile completed",
  "First application or offer in",
  "Hours logged",
  "Collective joined",
  "Story shared",
];

export function ChecklistCompleteDialog({ onClose }) {
  return (
    <Dialog open onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent data-testid="checklist-complete-dialog" className="sm:max-w-md">
        <DialogHeader>
          <div className="text-[11px] uppercase tracking-[0.2em] text-terracotta font-bold">All set</div>
          <DialogTitle className="font-display text-3xl text-forest tracking-tight">
            You've done the full circuit
          </DialogTitle>
          <DialogDescription>
            Profile, first application, hours, a collective and a story — the whole journey. From here it's all yours.
          </DialogDescription>
        </DialogHeader>
        <ul className="space-y-2">
          {CIRCUIT.map((line) => (
            <li key={line} className="flex items-center gap-2.5 text-sm text-neutral-700">
              <CheckCircle2 className="w-4 h-4 text-forest shrink-0" /> {line}
            </li>
          ))}
        </ul>
        <div className="flex justify-end">
          <Button data-testid="checklist-complete-dismiss" onClick={onClose} className="rounded-full bg-forest hover:bg-forest-hover">
            Keep going
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
